import { render, staticRenderFns } from "./PeopleAction.vue?vue&type=template&id=aab77ef2"
import script from "./PeopleAction.vue?vue&type=script&lang=ts"
export * from "./PeopleAction.vue?vue&type=script&lang=ts"
import style0 from "./PeopleAction.vue?vue&type=style&index=0&id=aab77ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports